<template>
    <div class="mobile">
        <img src="@/assets/mobile/bg.png" alt="" class="bg">
        <img src="@/assets/mobile/logo.png" alt="" class="logo">
        <img src="@/assets/mobile/video.png" alt="" class="play">
        <div class="download-wrapper">
            <a href="https://apk-cdn.jinkejoy.com/tom/Tompark/Tompark.apk" target="_blank"><img src="@/assets/mobile/android.png" alt="" class="android"></a>
            <img src="@/assets/mobile/ios.png" alt="" class="ios">
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="stylus" scoped>
.mobile
    position relative
    width 7.5rem
    height 13.34rem
    margin 0 auto

    .bg
        width 100%
        height 100%

    .logo
        position absolute
        width 7.5rem
        height 4.4rem
        left 50%
        top 0rem
        transform translateX(-50%)

    .play
        position absolute
        width .96rem
        height .96rem
        right 1.16rem
        top 1.95rem

    .download-wrapper
        display flex
        flex-direction column
        position absolute
        left 50%
        top 5.8rem
        transform translateX(-50%)

        img
            width 3.72rem
            height 1.08rem
</style>